/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SignatureRequestDto } from './SignatureRequestDto';
import {
    SignatureRequestDtoFromJSON,
    SignatureRequestDtoFromJSONTyped,
    SignatureRequestDtoToJSON,
    SignatureRequestDtoToJSONTyped,
} from './SignatureRequestDto';

/**
 * 
 * @export
 * @interface SignatureProgressDto
 */
export interface SignatureProgressDto {
    /**
     * 
     * @type {number}
     * @memberof SignatureProgressDto
     */
    totalRequired: number;
    /**
     * 
     * @type {number}
     * @memberof SignatureProgressDto
     */
    totalSigned: number;
    /**
     * 
     * @type {Array<SignatureRequestDto>}
     * @memberof SignatureProgressDto
     */
    signatureRequests: Array<SignatureRequestDto>;
    /**
     * Whether the current user has a pending signature request
     * @type {boolean}
     * @memberof SignatureProgressDto
     */
    isSignable: boolean;
    /**
     * Whether the current user has already signed
     * @type {boolean}
     * @memberof SignatureProgressDto
     */
    isSigned: boolean;
}

/**
 * Check if a given object implements the SignatureProgressDto interface.
 */
export function instanceOfSignatureProgressDto(value: object): value is SignatureProgressDto {
    if (!('totalRequired' in value) || value['totalRequired'] === undefined) return false;
    if (!('totalSigned' in value) || value['totalSigned'] === undefined) return false;
    if (!('signatureRequests' in value) || value['signatureRequests'] === undefined) return false;
    if (!('isSignable' in value) || value['isSignable'] === undefined) return false;
    if (!('isSigned' in value) || value['isSigned'] === undefined) return false;
    return true;
}

export function SignatureProgressDtoFromJSON(json: any): SignatureProgressDto {
    return SignatureProgressDtoFromJSONTyped(json, false);
}

export function SignatureProgressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatureProgressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalRequired': json['totalRequired'],
        'totalSigned': json['totalSigned'],
        'signatureRequests': ((json['signatureRequests'] as Array<any>).map(SignatureRequestDtoFromJSON)),
        'isSignable': json['isSignable'],
        'isSigned': json['isSigned'],
    };
}

export function SignatureProgressDtoToJSON(json: any): SignatureProgressDto {
    return SignatureProgressDtoToJSONTyped(json, false);
}

export function SignatureProgressDtoToJSONTyped(value?: SignatureProgressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalRequired': value['totalRequired'],
        'totalSigned': value['totalSigned'],
        'signatureRequests': ((value['signatureRequests'] as Array<any>).map(SignatureRequestDtoToJSON)),
        'isSignable': value['isSignable'],
        'isSigned': value['isSigned'],
    };
}

